<template>
  <div
    class="bg-danger-50 border-danger-100 text-danger-500 flex items-center rounded-lg border p-4 text-sm"
    :data-test="'TCalloutExclamationBlock-' + props.dataTestName"
  >
    <TIcon
      name="error"
      class="text-danger-500 mr-2 block h-8 w-8"
      aria-hidden="true"
    />
    <div class="text-danger-500">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  dataTestName: { type: String, required: false, default: '' },
});
</script>
